import React, { useState } from 'react';

const dev_actions1 = [
  { code: 1, target: 'Restart Device', options: null },
  {
    code: 2,
    target: 'Restart Duration',
    options: [
      { value: 1, inputtarget: '1s Restart' },
      { value: 7, inputtarget: '7s Hard Off' },
    ],
  },
  {
    code: 3,
    target: 'Set Brightness',
    options: [
      { value: 10, inputtarget: '10%' },
      { value: 50, inputtarget: '50%' },
      { value: 100, inputtarget: '100%' },
    ],
  },
  { code: 4, target: 'Enable WiFi', options: null },
  {
    code: 5,
    target: 'Select Mode',
    options: [
      { value: 'eco', inputtarget: 'Eco Mode' },
      { value: 'perf', inputtarget: 'Performance' },
      { value: 'bal', inputtarget: 'Balanced' },
    ],
  },
  { code: 6, target: 'Shutdown', options: null },
  {
    code: 7,
    target: 'User Profile',
    options: [
      { value: 'admin', inputtarget: 'Admin' },
      { value: 'guest', inputtarget: 'Guest' },
    ],
  },
  { code: 8, target: 'Update Firmware', options: null },
  {
    code: 9,
    target: 'Set Timeout',
    options: [
      { value: 5, inputtarget: '5 mins' },
      { value: 15, inputtarget: '15 mins' },
      { value: 30, inputtarget: '30 mins' },
    ],
  },
  { code: 10, target: 'Restart Network', options: null },
];

const CompactCommandList = (props) => {
  //console.log(props)

  const {dev_actions, t_activator_actions_fromForm} = props
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleSelectChange = (id, value) => {
    setSelectedOptions(prev => ({ ...prev, [id]: value }));
  };

  const handleCommand = (id, value = null) => {
    const msg = value
      ? `Command #${id} sent with value: ${value}`
      : `Command #${id} sent`;
      
    alert(msg);
    t_activator_actions_fromForm({[id]: value});
    //t_activator_actions_fromForm({3: '1', 4: ''})
    // Replace with actual API or logic
  };

  return (
    <div className="container py-3">
      <h5 className="mb-3">Device Action Commands</h5>
      <div className="row">
        {dev_actions.map((cmd) => (
          <div className="col-12 col-md-6 col-lg-4 mb-3" key={cmd.code}>
            <div className="border rounded p-2 bg-light h-100 d-flex flex-column justify-content-between small-card">
              <div className="mb-2">
                <strong>#{cmd.code}</strong> — {cmd.target}
              </div>

              {cmd.options ? (
                <div className="d-flex">
                  <select
                    className="form-select form-select-sm me-2"
                    onChange={(e) => handleSelectChange(cmd.code, e.target.value)}
                    value={selectedOptions[cmd.code] || ''}
                  >
                    <option value="">Choose...</option>
                    {cmd.options.map((opt, index) => (
                      <option key={index} value={opt.value}>
                        {opt.inputtarget}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleCommand(cmd.code, selectedOptions[cmd.code])}
                    disabled={!selectedOptions[cmd.code]}
                  >
                    Send
                  </button>
                </div>
              ) : (
                <button
                  className="btn btn-sm btn-primary w-100"
                  onClick={() => handleCommand(cmd.code)}
                >
                  Send
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompactCommandList;
